<span class="caption setting-label">{{ label }}</span>
<div class="value-and-reset">
  <span class="subtitle-03 value-label">{{ value }}</span>
  <button class="reset-button" (click)="resetValue.emit()" matRipple>
    <mat-icon [h3CustomIcon]="resetIcon"></mat-icon>
  </button>
</div>
